export default __webpack_public_path__ + "static/media/PRESTIGIO_MARQUINIA-LUCIDO_MESH_120X278_04_265.5875629c.jpg";